import { defineAsyncComponent, markRaw } from 'vue';

import { ScentrePredefinedSegmentTypes } from '@/common/components/targeting/scentre/ScentrePredefinedSegmentTypes';
import ScentreUtils from '@/common/components/targeting/scentre/ScentreUtils';
import { Demographic } from '@/common/models';
import { DASH, titlecase } from '@/globals';

const IconAudienceSegmentPlaceholder = defineAsyncComponent(
  () => import('@/common/icons/audience-segments/TumbUp.vue'),
);
const AlwaysOnTrend = defineAsyncComponent(() => import('@/common/icons/audience-segments/scentre/AlwaysOnTrend.vue'));
const Belonging = defineAsyncComponent(() => import('@/common/icons/audience-segments/scentre/Belonging.vue'));
const BrowsingAsEntertainment = defineAsyncComponent(
  () => import('@/common/icons/audience-segments/scentre/BrowsingAsEntertainment.vue'),
);
const ConsciousInvestment = defineAsyncComponent(
  () => import('@/common/icons/audience-segments/scentre/ConsciousInvestment.vue'),
);
const LimitedEdition = defineAsyncComponent(
  () => import('@/common/icons/audience-segments/scentre/LimitedEdition.vue'),
);
const QualityInvestment = defineAsyncComponent(
  () => import('@/common/icons/audience-segments/scentre/QualityInvestment.vue'),
);
const SalesScout = defineAsyncComponent(() => import('@/common/icons/audience-segments/scentre/SalesScout.vue'));
const SpecificNeed = defineAsyncComponent(() => import('@/common/icons/audience-segments/scentre/SpecificNeed.vue'));

export default class ScentrePredefinedSegment {
  id: number;

  demographic: Demographic;

  constructor(demographic: Demographic) {
    this.id = demographic.id;
    this.demographic = demographic;
  }

  get code() {
    return this.demographic?.code?.split(ScentreUtils.codes.predefinedSegment)[1] || null;
  }

  get name(): string {
    return this.demographic?.name ? titlecase(this.demographic.name) : DASH;
  }

  get icon(): unknown {
    switch (this.code) {
      case ScentrePredefinedSegmentTypes.ALWAYS_ON_TREND:
        return markRaw(AlwaysOnTrend);
      case ScentrePredefinedSegmentTypes.BELONGING:
        return markRaw(Belonging);
      case ScentrePredefinedSegmentTypes.BROWSING_AS_ENTERTAINMENT:
        return markRaw(BrowsingAsEntertainment);
      case ScentrePredefinedSegmentTypes.CONSCIOUS_COLLECTION:
        return markRaw(ConsciousInvestment);
      case ScentrePredefinedSegmentTypes.LIMITED_EDITION:
        return markRaw(LimitedEdition);
      case ScentrePredefinedSegmentTypes.QUALITY_INVESTMENT:
        return markRaw(QualityInvestment);
      case ScentrePredefinedSegmentTypes.SALES_SCOUT:
        return markRaw(SalesScout);
      case ScentrePredefinedSegmentTypes.SPECIFIC_NEED:
        return markRaw(SpecificNeed);
      default:
        return markRaw(IconAudienceSegmentPlaceholder);
    }
  }
}
